import * as S from "./AlertIdBox.style";
import { Buttons } from "@/components/atoms/Buttons";
import { useNavigate } from "react-router";
import { ReactComponent as IconChecked } from "@/styles/assets/svg/icon_checked_large.svg";

interface AlertMessageBoxProps {
  data: string;
}

export const AlertIdBox = (props: AlertMessageBoxProps) => {
  const navigate = useNavigate();
  return (
    <S.AlertMessageBox>
      <IconChecked />
      <S.AlertMessageText>
        <span>회원님의 아이디는</span>
        <span>
          <S.Highlight>{`${props.data}`}</S.Highlight>
        </span>
        <span>입니다.</span>
      </S.AlertMessageText>
      <S.BtnHighlight>
        <Buttons
          type="button"
          size="join"
          color="primary100"
          layout="text"
          label="비밀번호 찾기"
          onClick={() => navigate("/auth/account/find-password")}
        />
      </S.BtnHighlight>
    </S.AlertMessageBox>
  );
};
